export default "__VITE_PUBLIC_ASSET__2a41f35e__"